// src/components/pages/Movimento/index/mrt/resolveMovimentoListBoot.js
import { resolveSituacaoDefault } from './helpers/resolveSituacaoDefault';

export function resolveMovimentoListBoot({ operacao, profile, parametro, primeiroDia, ultimoDia, origem }) {
    // defaults base (seguros)
    const columnFilterFns = {
        data: 'between',
        transformado: 'equals',
        'Situacao.descricao': 'equals',
        ...(origem ? { origem: 'equals' } : { origem: 'empty' }),
    };

    const columnFilters = [
        { id: 'data', value: [primeiroDia, ultimoDia] },
        { id: 'transformado', value: '0' },
        { id: 'origem', value: origem },
    ];

    let sorting = [];

    // 🔵 REGRA DE SITUAÇÃO (contextual)
    const situacaoDefault = resolveSituacaoDefault({ operacao, profile });

    if (situacaoDefault) {
        columnFilters.push({
            id: 'Situacao.descricao',
            value: situacaoDefault,
        });
    }

    return {
        columnFilterFns,
        columnFilters,
        sorting,
    };
}
